module.exports = __webpack_public_path__ + "static/media/giant_paper_straw1.a8636f91.png";